import GovernmentAgencyDetails from "./GovernmentAgencyDetails";

export default GovernmentAgencyDetails;
